module.exports = __webpack_public_path__ + "img/bar-chart-blue.63ab0773.svg";